<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="onClose()">
  <div
    class="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-[2rem] shadow-2xl border border-slate-100 dark:border-slate-800 flex flex-col max-h-[92vh] overflow-hidden animate-fade-in-up"
    (click)="$event.stopPropagation()">

    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/80 dark:bg-slate-900/80 z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between gap-4 bg-white dark:bg-slate-900">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">{{ isEdit ? 'edit' : 'add_circle' }}</span>
          {{ isEdit ? 'แก้ไข Amount Map' : 'เพิ่ม Amount Map' }}
        </h3>
        <p class="text-sm text-slate-500 dark:text-slate-400 mt-1 font-medium">
          กำหนดยอดเงิน exact และจับคู่กับ Discount Rate
        </p>
      </div>
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto px-6 md:px-8 py-6 custom-scrollbar space-y-5 bg-white dark:bg-slate-900">
      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          Amount (exact) <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">payments</span>
          <input type="number" step="0.01" [(ngModel)]="formData.amount" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">
          Discount Rate <span class="text-rose-500">*</span>
        </label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">local_offer</span>
          <select [(ngModel)]="formData.parkingRateId" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
            <option [ngValue]="0">— เลือก Discount Rate —</option>
            <option *ngFor="let r of rateOptions" [ngValue]="r.id">{{ r.rateId }} — {{ r.name }}</option>
          </select>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Name</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">badge</span>
          <input [(ngModel)]="formData.name" [disabled]="isSaving()" placeholder="ชื่อ map (ถ้ามี)"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none placeholder:text-slate-400 disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Sequence</label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-lg pointer-events-none">format_list_numbered</span>
          <input type="number" [(ngModel)]="formData.sequence" [disabled]="isSaving()"
            class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium focus:outline-none disabled:opacity-50">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-2">Remark</label>
        <textarea [(ngModel)]="formData.remark" rows="3" [disabled]="isSaving()" placeholder="หมายเหตุเพิ่มเติม"
          class="w-full px-4 py-3 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-sm font-medium outline-none focus:ring-2 focus:ring-amber-200 dark:focus:ring-amber-500/30 resize-none disabled:opacity-50 placeholder:text-slate-400"></textarea>
      </div>

      <label class="inline-flex items-center gap-3 cursor-pointer select-none">
        <span class="relative inline-flex h-5 w-5 items-center justify-center">
          <input type="checkbox" id="mapActive" class="peer sr-only" [(ngModel)]="formData.active" [disabled]="isSaving()">
          <span
            class="absolute inset-0 rounded-md border-2 border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 transition-all peer-checked:border-amber-400 peer-checked:bg-amber-400 peer-focus-visible:ring-2 peer-focus-visible:ring-amber-200 peer-disabled:opacity-50"></span>
          <span class="material-icons relative z-[1] text-white text-[14px] leading-none opacity-0 transition-opacity peer-checked:opacity-100 pointer-events-none">check</span>
        </span>
        <span class="text-sm font-bold text-slate-700 dark:text-slate-200">Active</span>
      </label>
    </div>

    <div class="flex-none px-6 md:px-8 py-5 border-t border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row justify-between gap-3 bg-white dark:bg-slate-900">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()" [disabled]="isSaving()"
        class="px-4 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:border-amber-400 hover:text-amber-600 inline-flex items-center justify-center gap-2 disabled:opacity-50 cursor-pointer">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex flex-col sm:flex-row justify-end gap-3 ml-auto w-full sm:w-auto">
      <button type="button" (click)="onClose()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors disabled:opacity-50">
        ยกเลิก
      </button>
      <button type="button" (click)="onSave()" [disabled]="isSaving() || isLoading()"
        class="px-6 py-2.5 rounded-xl bg-amber-400 hover:bg-amber-500 text-white font-bold shadow-lg shadow-amber-200/50 dark:shadow-amber-900/30 transition-all disabled:opacity-50">
        {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
      </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && itemId"
  [entityType]="activityEntityTypes.StampAmountMap"
  [entityId]="itemId"
  title="ประวัติจับคู่ยอด Stamp"
  [subtitle]="'#' + itemId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
